import { logger } from '@/util/logger';

// scrollJump interface
// jumps a scroll container's position to a child element with class 'js-jumpto' on page load
var $ = window.$;
let _targets = 0;

// modification of jQuery .scrollParent method to fit our needs.
function _getVerticalScrollParent(element, includeHidden) {
	var style = getComputedStyle(element);
	var excludeStaticParent = style.position === 'absolute';
	var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

	if (style.position === 'fixed') return document.body;
	for (var parent = element; (parent = parent.parentElement);) {
		style = getComputedStyle(parent);
		if (excludeStaticParent && style.position === 'static') {
			continue;
		}
		// we only care if the container is scrollable if scrollbars are ACTUALLY visible
		if (parent.scrollHeight > parent.clientHeight && overflowRegex.test(style.overflow + style.overflowY)) return parent;
	}

	return document.documentElement;
}

function _getView(scrollContainer) {

	// check if this is a maintain scroll position container. If so, set that position as the top of the view
	var st = window.storedScrollPositions[scrollContainer.id] || scrollContainer.scrollTop;
	return [st, st + scrollContainer.clientHeight];
}
function _isOutOfView(view, position, buffer) {

	if (view[0] + buffer > position || view[1] - buffer < position) {
		return true;
	}

	return false;
}

function _getScrollPositionByID(id) {
	var pos = 0;
	var $elem = $('#' + positions[id]);
	var scrollParent = _getVerticalScrollParent($elem[0]);

	pos = scrollParent === document ? $elem.offset().top : $elem.offset().top - $(scrollParent).offset().top;
	pos += Math.min($elem.height() / 4, scrollParent.clientHeight / 4);

	return pos;
}
function _jump(id) {
	_targets--;
	var basePos = _getScrollPositionByID(id);
	if (typeof basePos !== 'number') {
		logger.warn('No jump position queued for scrollContainer ' + id);
		return;
	}

	var scrollContainer = id === 'document' ? document.documentElement : document.getElementById(id);

	if (scrollContainer === null) {
		logger.warn('cannot jump scroll position for ' + id + ' no matching element found');
		return;
	}

	var scrollPos = 0;
	var ch = scrollContainer.clientHeight;
	var buffer = ch / 10;
	var view = _getView(scrollContainer);

	// only jump container if it is out of view
	if (_isOutOfView(view, basePos, buffer)) {
		scrollPos = basePos - (ch / 2);
		if (typeof window.storedScrollPositions[scrollContainer.id] !== 'undefined') {
			window.storedScrollPositions[scrollContainer.id] = scrollPos;
			//logger.log('updating maintain scroll panel position for ' + id + ' to ' + scrollPos)
		} else {
			scrollContainer.scrollTop = scrollPos;
			//logger.log('scrolling ' + id + ' to ' + scrollPos);
		}

		// if we don't do this for the document element then the scroll position we set will get overridden immediately after we set it
		if (scrollContainer === document.documentElement && 'scrollRestoration' in window.history) {
			history.scrollRestoration = 'manual';

			if (document.readyState === 'complete') {
				setTimeout(function() {
					history.scrollRestoration = 'auto';
				},1000);
			} else {
				$(window).on('load', function() {
					setTimeout(function() {
						history.scrollRestoration = 'auto';
					}, 1000);
				});
			}
		}
	}

	positions[id] = null;
}

function _jumpAll() {

	for (let id in positions) {
		if (positions.hasOwnProperty(id)) {
			_jump(id);
		}
	}
}

export let positions = {};

export function reset() {
	positions = {};
}

export function queue($elem) {
	_targets++;
	var scrollParent = _getVerticalScrollParent($elem[0]);
	var scrollParentID = scrollParent === document.documentElement ? 'document' : scrollParent.id;

	if (scrollParentID in positions) {
		logger.warn('A jump position is already queued for container ' + scrollParentID + '. This one will be ignored.');
		return;
	}

	positions[scrollParentID] = $elem.attr('id');
	return scrollParentID;
}

export function immediateJump($elem) {
	// queues and jumps an elements scroll parent to its position immediately.
	var scrollParentID = queue($elem);

	// make sure we get a valid scrollParentID.
	// if we don't it is probably because a scroll position for
	// that element has already been queued.
	if (scrollParentID) {
		_jump(scrollParentID);
	}
}

export const init = function() {
	try {
		// scroll position can be queued either by adding the js-jumpto class to an element or
		// by directly calling the queue function before init
		$('.js-jumpto').each(function() {
			queue($(this));
			$(this).removeClass('js-jumpto');
		});

		if (_targets > 0) {
			_jumpAll();
		}
	} catch (err) {
		logger.log(err);
	}
};


